module.exports = {
	"name": "yagol",
	"version": "1.1.0",
	"description": "Yagol is a Conway's Game of Life sandbox game made with react. Customize the different options then create, share and watch your shapes evolve.",
	"author": "Benjamin Blonde",
	"license": "MIT",
	"url": "http://sarcadass.github.io/yagol",
	"private": true,
	"homepage": ".",
	"repository": {
		"type": "git",
		"url": "https://github.com/sarcadass/yagol"
	},
	"dependencies": {
		"babel-plugin-react-svg": "^2.1.0",
		"react": "^15.6.1",
		"react-dom": "^15.6.1",
		"react-modal": "^3.1.10",
		"react-notification-system": "^0.2.15",
		"react-svg-loader": "^2.1.0"
	},
	"devDependencies": {
		"autoprefixer": "6.7.2",
		"babel-core": "^6.26.3",
		"babel-eslint": "7.1.1",
		"babel-jest": "18.0.0",
		"babel-loader": "6.2.10",
		"babel-preset-react-app": "^2.2.0",
		"babel-runtime": "^6.26.0",
		"case-sensitive-paths-webpack-plugin": "1.1.4",
		"chalk": "1.1.3",
		"connect-history-api-fallback": "1.3.0",
		"cross-spawn": "4.0.2",
		"css-loader": "0.26.1",
		"detect-port": "1.1.0",
		"dotenv": "2.0.0",
		"eslint": "3.16.1",
		"eslint-config-react-app": "^0.6.2",
		"eslint-loader": "1.6.0",
		"eslint-plugin-flowtype": "2.21.0",
		"eslint-plugin-import": "^2.12.0",
		"eslint-plugin-jsx-a11y": "4.0.0",
		"eslint-plugin-react": "6.4.1",
		"extract-text-webpack-plugin": "1.0.1",
		"file-loader": "0.10.0",
		"fs-extra": "0.30.0",
		"html-webpack-plugin": "2.24.0",
		"http-proxy-middleware": "^0.18.0",
		"jest": "18.1.0",
		"json-loader": "0.5.4",
		"object-assign": "4.1.1",
		"postcss-loader": "1.2.2",
		"promise": "7.1.1",
		"react-dev-utils": "^0.5.2",
		"style-loader": "0.13.1",
		"url-loader": "0.5.7",
		"webpack": "1.14.0",
		"webpack-dev-server": "1.16.2",
		"webpack-manifest-plugin": "1.1.0",
		"whatwg-fetch": "2.0.2"
	},
	"scripts": {
		"start": "node scripts/start.js",
		"build": "node scripts/build.js",
		"test": "node scripts/test.js --env=jsdom"
	},
	"jest": {
		"collectCoverageFrom": [
			"src/**/*.{js,jsx}"
		],
		"setupFiles": [
			"<rootDir>/config/polyfills.js"
		],
		"testPathIgnorePatterns": [
			"<rootDir>[/\\\\](build|docs|node_modules|scripts)[/\\\\]"
		],
		"testEnvironment": "node",
		"testURL": "http://localhost",
		"transform": {
			"^.+\\.(js|jsx)$": "<rootDir>/node_modules/babel-jest",
			"^.+\\.css$": "<rootDir>/config/jest/cssTransform.js",
			"^(?!.*\\.(js|jsx|css|json)$)": "<rootDir>/config/jest/fileTransform.js"
		},
		"transformIgnorePatterns": [
			"[/\\\\]node_modules[/\\\\].+\\.(js|jsx)$"
		],
		"moduleNameMapper": {
			"^react-native$": "react-native-web"
		}
	},
	"babel": {
		"presets": [
			"react-app"
		]
	},
	"eslintConfig": {
		"extends": "react-app"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 140
// module chunks = 0